<template>
  <el-dialog
    title="文章推荐"
    :visible.sync="visible"
    :before-close="closeDialog"
    @closed="closeDialog"
    width="30%"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="120px">
      <el-form-item label="推荐开始时间" prop="publish_start_time">
        <el-date-picker
          v-model="formData.publish_start_time"
          type="datetime"
          value-format="timestamp"
          placeholder="开始时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="推荐结束时间" prop="publish_end_time">
        <el-date-picker
          v-model="formData.publish_end_time"
          type="datetime"
          value-format="timestamp"
          placeholder="结束时间空为一直推荐"></el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'article_publish',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      formData: {
        publish_start_time: '',
        publish_end_time: ''
      },
      formRules: {
        publish_start_time: [
          { required: true, message: '推荐时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRef.resetFields()
      this.$emit('closePublish')
    },
    confirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.$emit('publish', this.id, this.formData.publish_start_time, this.formData.publish_end_time)
      })
    }
  }
}
</script>

<style>
</style>
